module.exports = __webpack_public_path__ + "static/media/mbs_5.638f3557.jpg";